module.exports = __webpack_public_path__ + "img/402.1be6a3dd.png";